<template>
  <div id="service">   
    <ServiceComponent></ServiceComponent>     
  </div>
</template>

<script>

  import ServiceComponent from '@/components/cust_components/service_component.vue';
  
  export default {
      name: 'ServiceView',
      data() {
          return {
          }
      },
      components: {     
        ServiceComponent,
      }
  }
</script>